import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Table, Spinner, useStateContext, DropdownMenu } from '@veda/dashboard-ui';
import { useProcedimentiAssegnati } from '../hooks/useProcedimento';

const STATO_COLORS = {
  bozza:    'bg-gray-100 text-gray-700',
  avviato:  'bg-blue-100 text-blue-700',
  sospeso:  'bg-yellow-100 text-yellow-700',
  concluso: 'bg-green-100 text-green-700',
  archiviato:'bg-gray-200 text-gray-500',
};

function StatoBadge({ stato, _locate }) {
  const STATO_KEYS = {
    bozza: 'ppp_stato_bozza', avviato: 'ppp_stato_avviato',
    sospeso: 'ppp_stato_sospeso', concluso: 'ppp_stato_concluso', archiviato: 'ppp_stato_archiviato',
  };
  return (
    <span className={`px-2 py-0.5 rounded text-xs font-medium ${STATO_COLORS[stato] ?? ''}`}>
      {_locate(STATO_KEYS[stato] ?? stato) ?? stato}
    </span>
  );
}

export default function ProcedimentiAssegnati() {
  const navigate = useNavigate();
  const { _locate } = useStateContext();
  const { procedimenti, loading } = useProcedimentiAssegnati();

  const cols = [
    { name: 'action',  label: '',                        size: 'w-10 max-w-[40px]', orderable: 0 },
    { name: 'titolo',  label: _locate('ppp_col_titolo') },
    { name: 'rupNome', label: _locate('ppp_col_rup'),   size: 'w-40' },
    { name: 'stato',   label: _locate('ppp_col_stato'), size: 'w-28' },
  ];

  const cells_style = {
    action: (row) => (
      <DropdownMenu
        menu_items={[
          <button
            key="apri"
            onClick={() => navigate(`/ppp/${row.id}`)}
            className="w-full flex items-center gap-4 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
          >
            <span>{_locate('ppp_apri')}</span>
          </button>,
        ]}
      />
    ),
    titolo: (row) => (
      <div
        className="cursor-pointer"
        onClick={() => navigate(`/ppp/${row.id}`)}
      >
        <div className="text-xs font-bold text-[#555454] dark:text-dark-text-normal hover:text-gray-400 dark:hover:text-[#a9a68e]">
          {row.titolo}
        </div>
        <div className="text-xs text-[#828c95] mt-0.5">
          {row.enteConcedente}
          {row.enteConcedente && (row.faseAttiva || _locate('ppp_non_avviato')) ? ' · ' : ''}
          {row.faseAttiva
            ? `${_locate('ppp_tab_fasi')} ${row.faseAttiva}`
            : _locate('ppp_non_avviato')}
        </div>
      </div>
    ),
    rupNome: (row) => <span className="text-xs">{row.rupNome ?? '—'}</span>,
    stato:   (row) => <StatoBadge stato={row.stato} _locate={_locate} />,
  };

  return (
    <div className="p-6">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">
          {_locate('ppp_assegnati_titolo')}
        </h1>
        <p className="text-sm text-gray-500 mt-1">{_locate('ppp_assegnati_sottotitolo')}</p>
      </div>

      {loading ? (
        <div className="flex items-center justify-center h-40">
          <Spinner />
        </div>
      ) : (
        <Table
          id="ppp-assegnati"
          dataset={procedimenti}
          cols={cols}
          cells_style={cells_style}
          loading={loading}
        />
      )}
      </div>
    </div>
  );
}
